import React from 'react';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import { Link as RouterLink } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const NotFound: React.FC = () => {
  const { token } = useAuth();

  return (
    <Box sx={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', px: 2 }}>
      <Paper variant="outlined" sx={{ p: { xs: 4, md: 6 }, maxWidth: 520, textAlign: 'center' }}>
        <SearchOffIcon sx={{ fontSize: 72, color: 'rgba(7,24,45,0.15)', mb: 2 }} />
        <Typography variant="h2" fontWeight={900} sx={{ color: 'rgba(7,24,45,0.15)', lineHeight: 1 }}>
          404
        </Typography>
        <Typography variant="h5" fontWeight={700} mt={1}>
          Page not found
        </Typography>
        <Typography variant="body2" color="text.secondary" mt={1} mb={3.5}>
          The page you are looking for might have been moved, renamed, or doesn't exist.
        </Typography>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} justifyContent="center">
          <Button component={RouterLink} to="/" variant="contained" color="primary">
            Back to home
          </Button>
          <Button component={RouterLink} to={token ? '/app/rides' : '/rides'} variant="outlined">
            Browse rides
          </Button>
          <Button onClick={() => window.history.back()} variant="text">
            Go back
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
};

export default NotFound;
